module.exports = __webpack_public_path__ + "static/media/shutterstock_1479701399 [Converted].80cbda30.png";